export default __webpack_public_path__ + "static/service-3-4079e9b380c615e3096381b26381a252.webp";